import React from 'react'

export const NotFoundView = () => (
  <div>
    <h2>404</h2>
    <p>Page Not Found.</p>
  </div>
)

export default NotFoundView



// WEBPACK FOOTER //
// ./src/routes/NotFound/components/NotFoundView.js